import { getOddsValue } from "./common";

export const parseBankerOdds = (pmPool, message) => {
    if(message != null) {
        if(message.updAt != null && message.bk !=null){
            pmPool.lastUpdateTime = message.updAt;
            pmPool.oddsLastUpdateTime = message.updAt;
            message.bk.forEach(bkNode => {
                let targetComb = pmPool.oddsNodes.filter(x=> parseInt(x.combString)===bkNode.bkNo)[0];
                let bOdds = [];
                let newComb = {
                    bankerOdds:[],
                    combString: bkNode.bkNo,
                    hotFavourite: null,
                    oddsDropValue: null,
                    oddsValue: null
                }
                if(bkNode.bkTopN != null){
                    bkNode.bkTopN.forEach(comb => {
                    let bCmb = {
                            combString: comb.cmbStr,
                            oddsValue: getOddsValue(comb.odds, comb.cmbSt)
                        }
                        bOdds.push(bCmb);
                    });
                }
                if(bkNode.bkScrSt){
                    if(targetComb!=null){
                        targetComb.oddsValue = "SCR";
                        newComb.oddsValue = "SCR"
                    }
                }
                if(targetComb!=null){
                    targetComb.bankerOdds = bOdds;
                }else{
                    newComb.bankerOdds = bOdds;
                    pmPool.oddsNodes.push(newComb)
                }
            });
        }
    }
}